import { CONTRACT_PROGRESS_CREDENTIALS_UPDATE } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

interface ContractProgressParticipantState {
  name: string | null;
  participantId: string | null;
}

const initialState: ContractProgressParticipantState = {
  name: null,
  participantId: null,
};

export default function reducer(
  state: ContractProgressParticipantState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CREDENTIALS_UPDATE:
      return {
        name: null,
        participantId: action.payload.participantId,
      };
    default:
      return state;
  }
}
